import { render, staticRenderFns } from "./aggreementDialog.vue?vue&type=template&id=20a5a84e&scoped=true"
import script from "./aggreementDialog.vue?vue&type=script&lang=js"
export * from "./aggreementDialog.vue?vue&type=script&lang=js"
import style0 from "./aggreementDialog.vue?vue&type=style&index=0&id=20a5a84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5a84e",
  null
  
)

export default component.exports